var React = require('react');

function SpacerLineDesktop2Inline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.4","d":"M1 59V1H153","stroke":"white"}));
}

SpacerLineDesktop2Inline.defaultProps = {"className":"desktop-line-spacer","width":"153","height":"59","viewBox":"0 0 153 59","fill":"none"};

module.exports = SpacerLineDesktop2Inline;

SpacerLineDesktop2Inline.default = SpacerLineDesktop2Inline;
